import { useTranslation } from 'react-i18next';
import { ClockIcon } from '@heroicons/react/24/outline';
import {
  WIZARD_BODY_CLASS_NAME,
  WIZARD_ICON_CLASS_NAME,
  WIZARD_SCREEN_SUBTITLE_CLASS_NAME,
  WIZARD_SCREEN_TITLE_CLASS_NAME,
  WIZARD_TRANSLATION_NAMESPACE,
} from './WhatsAppConnectionWizard.constants';

export type tWhatsAppConnectionWizardActivationPendingProps = {
  /** Whether Meta has held the number past the support escalation time. */
  isPastEscalation: boolean;
};

/**
 * The main pane while Meta confirms the number. Nothing the person does
 * changes it, so it has no reconnect and a fixed icon instead of a spinner.
 * Past the escalation time it only says why; the advisor leads the footer.
 *
 * @param {tWhatsAppConnectionWizardActivationPendingProps} props - Whether the
 * hold passed the escalation time.
 * @returns {JSX.Element} The pending screen.
 */
export default function WhatsAppConnectionWizardActivationPending(
  props: tWhatsAppConnectionWizardActivationPendingProps,
) {
  const { isPastEscalation } = props;
  const { t } = useTranslation(WIZARD_TRANSLATION_NAMESPACE);

  return (
    <div className="flex flex-col gap-[var(--ls-spacing-6)]">
      <div className="flex flex-col gap-[var(--ls-spacing-2)]">
        <h2 className={WIZARD_SCREEN_TITLE_CLASS_NAME}>
          {t('wizard.activationPending.title')}
        </h2>
        <p className={WIZARD_SCREEN_SUBTITLE_CLASS_NAME}>
          {t('wizard.activationPending.subtitle')}
        </p>
      </div>
      <div className="flex gap-[var(--ls-spacing-2)]">
        <ClockIcon className={WIZARD_ICON_CLASS_NAME} aria-hidden="true" />
        <p className={WIZARD_BODY_CLASS_NAME}>
          {t(
            isPastEscalation
              ? 'wizard.activationPending.overAnHourBody'
              : 'wizard.activationPending.body',
          )}
        </p>
      </div>
    </div>
  );
}
